//#region src/utils/number.ts
/**
* Round a number to the given number of `decimalPlaces`.
*/
function round(num, decimalPlaces = 2) {
	return Number(num.toFixed(decimalPlaces));
}
/**
* Get the number of decimal places in the given `num`.
*
* @example `1 -> 0`
* @example `1.0 -> 0`
* @example `1.1 -> 1`
* @example `1.12 -> 2`
*/
function getNumberOfDecimalPlaces(num) {
	return String(num).split(".")[1]?.length ?? 0;
}
/**
* Clamp a given `value` between a minimum and maximum value.
*/
function clampNumber(min, value, max) {
	return Math.max(min, Math.min(max, value));
}
//#endregion
export { clampNumber, getNumberOfDecimalPlaces, round };
